import Table from "@/common/components/Table";
import { useFilterParams } from "@/common/hooks/useFilterParams";
import { Mapper } from "@/common/services/mapper";
import { governmentAllocationBillsTableColumns } from "@/features/billingBills/constants/billsTableColumns.constant";
import { BillsTransformer } from "@/features/billingBills/services/billsTransformer";
import { useGovernmentAllocationBills } from "@/features/governmentAllocations/hooks/governmentAllocationBills/useGovernmentAllocationBills";
import { GovernmentAllocationData } from "@/features/governmentAllocations/types/governmentAllocation.type";

interface GovernmentAllocationBillsProps {
  governmentAllocation: GovernmentAllocationData;
}

const GovernmentAllocationBills = ({
  governmentAllocation,
}: GovernmentAllocationBillsProps) => {
  const { filterParams, setFilterParams } = useFilterParams()

  const {
    data: governmentAllocationBills,
    isLoading: governmentAllocationBillsIsLoading,
    meta,
  } = useGovernmentAllocationBills({
    governmentAllocationId: governmentAllocation.id,
    filters: {
      page: filterParams.page || 1,
    },
    mapper: Mapper.mapWithTransformer({
      transformer: BillsTransformer.tableTransformer(),
    }),
  })

  return (
    <div className="flex flex-col gap-6">
      <Table
        className="min-h-[256px] max-h-[calc(100vh-432px)]"
        columns={governmentAllocationBillsTableColumns}
        rows={governmentAllocationBills}
        hasPagination
        page={filterParams.page || 1}
        setPage={(page) => setFilterParams((prev) => ({ ...prev, page }))}
        totalCount={meta.total}
        totalPages={meta.total_pages}
        isLoadingData={governmentAllocationBillsIsLoading}
        loadingRows={2}
        rowEmptyValue="--"
      />
    </div>
  );
}

export default GovernmentAllocationBills;
